import { useEffect, useState } from 'react';

/** Whole seconds left until a deadline set on mount — `seconds` from now, or an absolute `expiresAtSeconds`. */
export const useSecondsCountdown = ({ seconds, expiresAtSeconds }: { seconds?: number; expiresAtSeconds?: number }) => {
  const [expiresAt] = useState(() =>
    expiresAtSeconds !== undefined ? expiresAtSeconds * 1000 : Date.now() + (seconds ?? 0) * 1000
  );
  const [remaining, setRemaining] = useState(() => Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000)));

  useEffect(() => {
    const intervalId = setInterval(() => {
      const next = Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000));
      setRemaining(next);
      if (next <= 0) {
        clearInterval(intervalId);
      }
    }, 1000);
    return () => clearInterval(intervalId);
  }, [expiresAt]);

  return remaining;
};

export const formatMmSs = (totalSeconds: number) => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
};
